(function(angular) {

    function setVisibility(contact) {
        var callEl = angular.element(document.getElementById(`call-${contact.userName}`));
        var chatEl = angular.element(document.getElementById(`chat-${contact.userName}`));

        var togglePhone = (on) => {
            callEl.toggleClass('fa-phone', on);
            callEl.toggleClass('fa-fw', !on);
        };

        if (contact.isPresent && contact.canTxt) {
            chatEl.removeClass('ng-hide');
        } else {
            chatEl.addClass('ng-hide');
        }

        if (contact.callAlias && contact.canP2P) {
            if (!contact.disableP2P) {
                togglePhone(true);
            } else {
                togglePhone(false);
            }
        } else {
            togglePhone(false);
        }
    }

    angular
        .module('webcomm')
        .controller('ContactsController', [
            '$scope',
            '$log',
            '$timeout',
            'contactService',
            'userService',
            'anchorInfoService',
            function ($scope, $log, $timeout, contactService, userService, anchorInfoService) {

                $log.debug('Loading ContactsController');

                var contactsNav = {};
                var contacts = {};
                var start = 'A'.charCodeAt(0);
                var end = start + 26;
                var selfCanP2P = true;
                $scope.pageSize = 100; 
                $scope.aiService = anchorInfoService;
                $scope.contactService = contactService;
                $scope.visibleProvider = [];
                $scope.contactsByLetter = {};

                $scope.getNavKeys = function () {
                    let a = [];  
                    for (let x = start; x < end; x++) {
                        a.push(String.fromCharCode(x));
                    }
                    a.push('*'); //non-alphabet start char needs to be the last
                    return a;
                }

                /* Replace this with a call to a language service, to get a language specific keys */
                var navKeys = $scope.getNavKeys();

                /* Initialize contacts object with an empty array for each key in navKeys array */
                navKeys.forEach((l) => {
                    contactsNav[l] = [];
                });

                /* Get contacts into array based on row index */
                $scope.anchor =  $scope.aiService.createAnchor();

                let currIndex = $scope.anchor.value - $scope.anchor.before;
                contactService.getContacts($scope.anchor)
                    .then((result) => {
                        let c = '';
                        let currIndex = $scope.anchor.value;
                        result.data.forEach((d) => {
                            contacts[d.userName] = d;
                            c = d.name.substr(0, 1);
                            if (c.charCodeAt(0) >= 97 && c.charCodeAt(0) <= 122) {
                                c = c.toUpperCase();
                            }
                            if (c.charCodeAt(0) >= 65 && c.charCodeAt(0) <= 90) {
                                contactsNav[c].push(d);
                            }
                            else {
                                contactsNav['*'].push(d);
                            }
                            currIndex++;
                        });
                        $scope.totalContacts = result.totalContacts;
                        $scope.contactsByLetter = contactsNav;
  
                    });

                //  Will need to do a user service lookup to see the state of each user to determine if
                //  Phone icon should be visible

                var unbindContactJoined = $scope.$on('contactService.contactUpdated', (e, endpoint) => {
                    var contact = contacts[endpoint.userName.toLowerCase()];
                    if(contact) {
                        if (!contact.endpoints.has(endpoint.id)) {
                            if (contact.endpoints.size === 0) {
                                let unbindUserJoined = $scope.$on('userService.userJoined', (e, user) => {
                                    if (user.userName === endpoint.userName) {
                                        contact.canP2P = user.privateCallEnabled;

                                        $scope.$broadcast('contactController.contactJoined', contact);
                                        unbindUserJoined();
                                    }
                                });
                            }

                            contact.isPresent = true;
                            contact.endpoints.add(endpoint.id);
                        } else {

                            if (endpoint.disposition === 'Phone') {
                                contact.canP2P = false;
                            } else {
                                contact.canTxt = endpoint.privateTxtEnabled ? true : false;
                                contact.canP2P = true;
                                for (let ep of contact.endpoints) {
                                    if (ep.disposition === 'Phone') {
                                        contact.canP2P = false;
                                        break;
                                    }
                                }
                            }

                            if (selfCanP2P) {
                                $scope.$broadcast('contactController.contactUpdated', contact);
                            }
                        }
                    }
                });

                var unbindSelfUpdated = $scope.$on('contactService.selfUpdated', (e, endpoint) => {
                    var contact;
                    if(endpoint.disposition === 'Phone') {
                        selfCanP2P = false;
                        Object.getOwnPropertyNames(contacts).forEach((key) => {
                            contact = contacts[key];
                            if(contact.isPresent && contact.callAlias) {
                                contact.disableP2P = true;

                                $scope.$broadcast('contactController.contactUpdated', contact);
                            }
                        });
                    } else if(!selfCanP2P) {
                        selfCanP2P = true;
                        Object.getOwnPropertyNames(contacts).forEach((key) => {
                            contact = contacts[key];
                            if(contact.isPresent && contact.callAlias) {
                                delete contact.disableP2P;
                                contact.canP2P = true;

                                $scope.$broadcast('contactController.contactUpdated', contact);
                            }
                        });
                    }
                });

                var unbindContactOffline = $scope.$on('contactService.contactOffline', (e, endpointId, userName) => {
                    var contact = contacts[userName];

                    if (contact.endpoints.size === 1) {
                        contact.endpoints.clear();
                        contact.isPresent = false;
                        contact.canP2P = false;
                    } else {
                        contact.endpoints.delete(endpointId);
                    }

                    $scope.$broadcast('contactController.contactLeft', contact);
                });

                $scope.$on('destroy', function () {
                    unbindContactJoined();
                    unbindContactOffline();
                    unbindSelfUpdated();
                });

                $scope.$emit('timeForResize');
            }
        ])
        .directive('contactList', ['$compile','$log', function ($compile, $log) {
            return {
                templateUrl: 'app/main/contacts/contacts.html',
                restrict: 'E',
                link: function (scope, element) {

                       // add listener for scroll event
                       let contactEntries = angular.element(element[0].querySelector('#contact-entries'))[0];

                       // clear the view 
                       scope.clearView = function() {
                            let contactsNav = {'*': []};
                            scope.contactsByLetter = contactsNav;
                            console.log(" --- End of Clear View ----");
                       }

                       // define scroll event handler
                       scope.onScroll = function (evt) {

                       if (scope.onPageFaultHandling === true) {
                           console.log("ignores scroll event while page fault is processing");
                           return;
                       }

                        let target = evt.target; 
                        if (target.offsetHeight + target.scrollTop == target.scrollHeight) {
                            // get a new page if page fault occurred. 
                            if (scope.anchor.value + scope.anchor.after < scope.totalContacts - 1) {
                                console.log("Page fault detected at the bottom");
                                scope.viewportHeight = Math.floor(
                                    target.offsetHeight / target.scrollHeight * scope.pageSize);
                                scope.anchor.value += (scope.pageSize - scope.viewportHeight); 
                                // Load a new page and rendered it on the UI
                                console.log("Page fault at " + scope.anchor.value + ", out of " + scope.totalContacts);
                                scope.clearView(); 
                                scope.handlePageFault(scope.anchor); // page fault at the bottom
                            }

                            console.log("Touched bottom of scrollbar");
                        } else if (target.scrollTop == 0) {
                            $log.debug("touch scrollTop !");
                            
                            if (scope.anchor.value > 0) {
                                // Get a previous page 
                                let screenHeight = scope.viewportHeight | Math.floor(0.1 * scope.pageSize);
                                console.log("Reduced by " + screenHeight);
                                scope.anchor.value -= screenHeight; 
                                if (scope.anchor.value < 0) {
                                    scope.anchor.value = 0;
                                }
                                console.log("Page fault at the scroll top :" + scope.anchor.value);
                                scope.clearView(); 
                                scope.handlePageFault(scope.anchor); // page fault at the top
                            } else {
                                console.log("There is no more page at the beginning !!");
                            }
                        }
                    };

                   if (contactEntries) {
                       contactEntries.addEventListener("scroll", scope.onScroll);
                       console.log("added scroll listener !!")
                   } else {
                       console.log("Failed to find contactEntries ", element[0].innerHTML);
                   }

                    scope.scrollToView = function (key) {
                        // Get a new page based on key
                        // There is no way to search element from start_char as *

                        let table = angular.element(element[0].querySelector('#contacts-table-' + (key == '*' ? 'special' : key)))[0];
                        if (table) {
                            table.scrollIntoView();
                        } 
                    };

                    scope.handlePageFault = function (anchor) {
                        scope.onPageFaultHandling = true;
                        scope.contactService.getContacts(anchor)
                            .then((result) => {
                                let c = '';
                                let contactsNav = {};
                                let contacts = {};
                                /* Replace this with a call to a language service, to get a language specific keys */
                                var navKeys = scope.getNavKeys();

                                /* Initialize contacts object with an empty array for each key in navKeys array */
                                navKeys.forEach((l) => {
                                    contactsNav[l] = [];
                                });
                                let currIndex = scope.anchor.value - scope.anchor.before;
                                console.log(" <---- result listing starting index = ", currIndex);
                                for (let i = 0; i < 3 && i < result.data.length; i++) {
                                    console.log(" first data :" + result.data[i].userName + ", name= "+ result.data[i].name + ", callAlias = " + result.data[i].callAlias);
                                }
                                result.data.forEach((d) => {
                                    contacts[d.userName] = d;
                                    c = d.name.substr(0, 1);
                                   
                                    if (c.charCodeAt(0) >= 97 && c.charCodeAt(0) <= 122) {
                                        c = c.toUpperCase();
                                    }

                                    if (c.charCodeAt(0) >= 65 && c.charCodeAt(0) <= 90) {
                                        contactsNav[c].push(d);
                                    } else {
                                        contactsNav['*'].push(d);
                                    }
                                    currIndex++;
                                });
                                if (result.data.length > 0) {
                                    // clean the screen 
                                    scope.contactsByLetter = contactsNav;
                                    console.log("Just updating contacts information after page fault handling");
                                }
                            })
                            .catch( (err) => {
                                $log.debug("Exception at PageFault handling : " + err);
                                console.log("===> Exception caught : "+ err +" <===");
                            })
                            .finally( () => {
                                scope.onPageFaultHandling = false;
                            });
                    }

                    var unbindContactJoined = scope.$on('contactController.contactJoined', (e, d) => {
                        setVisibility(d);
                    });

                    var unbindContactLeft = scope.$on('contactController.contactLeft', (e, d) => {
                        setVisibility(d);
                    });

                    var unbindContactDispositionChanged = scope.$on('contactController.contactUpdated', (e, d) => {
                        setVisibility(d);
                    });

                    scope.$on('destroy', function (e) {
                        unbindContactJoined();
                        unbindContactLeft();
                        unbindContactDispositionChanged();
                    });
                },
                controller: 'ContactsController'
            };
        }])
        .controller('ContactListItemsController', [
            '$scope',
            '$log',
            '$timeout',
            'contactService',
            'privateCallService',
            'endpointModel',
            'channelModel',
            function ($scope, $log, $timeout, contactService, privateCallService, endpointModel, channelModel) {

            function isBargeCall(contact) {
                return contact.type === 'RADIO';
            }

                function makeCall(contact) {
                    privateCallService.callRequest(contact.callAlias, contact.userName, contact.name, isBargeCall(contact))
                        .then((resp) => {
                            $scope.$emit('makingCall', resp);
                        })
                        .catch(err => $log.error(err));
                }

                function openPrivateTalkgroup(contact) {
                    var myEndpoint = endpointModel.getMyEndpoint();
                    channelModel.selectChannel(channelModel.addOrUpdatePrivateCallChannel(2, myEndpoint.userName,
                        contact.userName, contact.callAlias, contact.name, null, contact.userName, isBargeCall(contact)));
                }

                var unbindContactAction = $scope.$on('contactAction', function (e, action, contact) {
                    if (action === 'call' && !isBargeCall(contact)) {
                        makeCall(contact);
                    } else if (action === 'chat') {
                        openPrivateTalkgroup(contact);
                    } else if ( isBargeCall(contact)) {
                        openPrivateTalkgroup(contact);
                        $scope.$emit('makingCall');
                    }
                });

                $scope.$on('destroy', function (e) {
                    unbindContactAction();
                });
            }
        ])
        .directive('contactListItems', ['$templateRequest', '$compile', function ($templateRequest, $compile) {
            return {
                restrict: 'E',
                scope: {
                    contacts: '='
                },
                replace: true,
                controller: 'ContactListItemsController',
                link: function (scope, element) {

                    $templateRequest('app/main/contacts/contactItem.html').then((html) => {
                        var template, nameEl, callEl, chatEl, buttons;
                        scope.contacts.forEach((contact) => {
                            template = angular.element(html);
                            buttons = template.find('i');
                            nameEl = angular.element(template.children()[0]);
                            callEl = angular.element(buttons[0]);
                            chatEl = angular.element(buttons[1]);
                            nameEl.html(contact.name)
                            callEl.attr('id', `call-${contact.userName}`);
                            chatEl.attr('id', `chat-${contact.userName}`);
                            buttons
                            //.data('userName', contact.userName)
                            //.data('classAlias', contact.callAlias)
                                .data('contact', contact)
                                .on('click', function () {
                                    let $this = angular.element(this);
                                    let action = $this.hasClass('call') ? 'call' : 'chat';
                                    //let user = $this.data('userName');
                                    //let number = $this.data('callAlias');
                                    if (action) {
                                        scope.$emit('contactAction', action, $this.data('contact'));
                                    }
                                });

                            element.append(template);
                            setVisibility(contact);
                        });
                    });
                }
            };
        }]);
})(angular);
